import useConfirmSyncEnergyPerformanceCertificate from '@/api/mutations/energyPerformanceCertificate/useConfirmSyncEnergyPerformanceCertificate';
import { SyncEnergyPerformanceCertificateConfirmationNeededResponse } from '@/api/mutations/energyPerformanceCertificate/useSyncEnergyPerformanceCertificate';
import {
  Alert,
  Badge,
  Card,
  CardButton,
  Modal,
  ModalProps,
  useToastContext,
} from '@payaca/ambrosia';

import { FC } from 'react';

type Props = {
  projectId?: string;
  addressId: string;
  certificates: SyncEnergyPerformanceCertificateConfirmationNeededResponse['certificates'];
} & Omit<ModalProps, 'title'>;

export const ConfirmSyncEnergyPerformanceCertificateModal: FC<Props> = (
  props
) => {
  const { projectId, addressId, certificates, ...modalProps } = props;

  const { pushSuccess } = useToastContext();

  const { mutateAsync, isPending, error } =
    useConfirmSyncEnergyPerformanceCertificate({ projectId });

  const onClick = (certificateNumber: string) => {
    if (isPending) return;
    void mutateAsync({ addressId, certificateNumber }).then(() => {
      pushSuccess('Your EPC has been synced successfully');
      modalProps.onClose?.();
    });
  };

  return (
    <Modal {...modalProps} title="Fetch EPC">
      <Modal.Body>
        {!!error && <Alert colour="red">Something went wrong</Alert>}
        <Alert colour="yellow" className="mb-4">
          Multiple energy performance certificates found. Please select the
          correct one from the list
        </Alert>
        <ul className="space-y-4 list-none m-0 p-0">
          {certificates.map((cert) => {
            const { certificateNumber } = cert.metadata;
            if (!certificateNumber) return null;
            return (
              <li key={certificateNumber}>
                <CardButton onClick={() => onClick(certificateNumber)}>
                  <Card.Body>
                    <div className="flex flex-row gap-4">
                      <div className="flex flex-col gap-2">
                        <Badge
                          colour="green"
                          variant="solid"
                          className="flex h-12 w-12 items-center justify-center text-xl font-bold"
                        >
                          {cert.energyPerformance.currentEnergyRating}
                        </Badge>
                      </div>
                      <div>
                        <p>
                          {cert.property.address}, {cert.property.postcode}
                        </p>
                        <p>
                          {cert.property.propertyType} (
                          {cert.property.builtForm})
                        </p>
                        <p>UPRN: {cert.property.uprn}</p>
                      </div>
                    </div>
                  </Card.Body>
                </CardButton>
              </li>
            );
          })}
        </ul>
      </Modal.Body>
    </Modal>
  );
};
